// extracted by mini-css-extract-plugin
export default {"taskWrap":"task_taskWrap__Lurso","container":"task_container__XMCus"};